angular.module('ons-LaForge-client', []);
